<template>
    <div class="survey-choose-rubric">
        <h4 class="title">{{ $t('rubrics.choose_rubric') }}</h4>
        <div class="rubrics">
            <div class="rubric-skill-sets">
                <b-form-group
                    class="rubric-skill-sets-group"
                    :label="$t('rubrics.choose_a_set_of_skills')">
                    <design-2021-apprentice-multiselect-component
                        v-model="selectedSkillTree"
                        :multiple-select="false"
                        label="name"
                        :options="skillTreesIn"
                        @input="setSkillTree($event)"
                        :placeholder="$t('rubrics.choose_a_skill_set')"
                        :show-labels="false">
                    </design-2021-apprentice-multiselect-component>
                </b-form-group>
            </div>

            <div class="rubric-skill">
                <b-form-group
                    class="rubric-skill-group"
                    :label="$t('rubrics.choose_a_skill')">
                    <design-2021-apprentice-multiselect-component
                        v-model="selectedSkill"
                        :multiple-select="false"
                        label="name"
                        :options="skills"
                        @input="setSkill($event)"
                        :show-labels="false"
                        :disabled="selectedSkillTree === null"
                        :placeholder="$t('rubrics.choose_a_skill')">
                    </design-2021-apprentice-multiselect-component>
                </b-form-group>
            </div>

            <div class="rubric">
                <b-form-group
                    class="rubric-group"
                    :label="$t('rubrics.choose_rubric')">
                    <design-2021-apprentice-multiselect-component
                        v-model="selectedRubric"
                        label="title"
                        :multiple-select="false"
                        :options="rubrics"
                        :show-labels="false"
                        :disabled="selectedSkill === null"
                        :placeholder="$t('rubrics.choose_rubric')">
                    </design-2021-apprentice-multiselect-component>
                </b-form-group>
            </div>
        </div>

        <b-button
            class="btn-add btn-add-survey"
            variant="primary"
            @click="addRubric()">
            {{ $t('rubrics.add_rubric') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-survey-choose-skills-component',
    props: {
        skillTreesIn: {
            type: Array,
            required: true,
        },
        moduleSkillTreesIn: {
            type: Array,
            required: false,
        },
        value: {
            type: [Array, Object],
        },
    },

    data() {
        return {
            selectedSkillTree: null,
            selectedSkill: null,
            selectedRubric: null,
            skills: [],
            selectedRubrics: this.value ? this.value : [],
            rubrics: [],
        };
    },
    methods: {
        setSkillTree(event) {
            if (!event) {
                return;
            }

            this.selectedSkillTree = event;

            this.skills = event.skill_skill_trees.map((item) => {
                return item.skill;
            });

            this.rubrics = [];
            this.selectedSkill = [];
            this.selectedRubric = [];
        },

        setSkill(event) {
            if (!event) {
                return;
            }

            this.selectedSkill = event;
            this.selectedRubric = null;

            for (const tree of this.selectedSkillTree.skill_skill_trees) {
                if (tree.skill_id === event.id) {
                    this.rubrics = tree.rubrics;
                }
            }

            this.rubrics = this.rubrics.map((rubric) => {
                if (
                    this.selectedRubrics.length &&
                    this.selectedRubrics.map((selectedRubric) => selectedRubric.rubricId).indexOf(rubric.id) !== -1
                ) {
                    rubric.$isDisabled = true;
                } else {
                    rubric.$isDisabled = false;
                }

                return rubric;
            });
        },

        addRubric() {
            this.selectedRubrics.push({
                rubricId: this.selectedRubric.id,
                skillTree: this.selectedSkillTree,
                skill: this.selectedSkill,
                rubric: this.selectedRubric,
            });

            this.$emit('input', this.selectedRubrics);

            if (this.moduleSkillTreesIn && !this.moduleSkillTreesIn.length) {
                this.selectedSkillTree = null;
                this.skills = [];
            }
            this.selectedSkill = null;
            this.rubrics = [];
            this.selectedRubric = null;
        },
    },

    watch: {
        value: {
            handler: function (val) {
                this.selectedRubrics = val;
                if (this.selectedRubrics && this.selectedRubrics.length === 0) {
                    this.rubrics = this.rubrics.map((rubric) => {
                        rubric.$isDisabled = false;
                        return rubric;
                    });
                } else {
                    this.rubrics = this.rubrics.map((rubric) => {
                        rubric.$isDisabled = !!(
                            this.selectedRubrics.length &&
                            this.selectedRubrics.map((selectedRubric) => selectedRubric.rubricId).indexOf(rubric.id) !==
                                -1
                        );
                        return rubric;
                    });
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
.btn-add-survey {
    width: 100%;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .btn-add-survey {
        width: auto;
        margin-left: auto;
    }
}
</style>
